import { DEFAULT } from '../../shared/constants/defaults';
import { NestedQuota } from '../../shared/interfaces/quota.interface';
import {
  MissingNestingGroupIdQuotaMatch,
  QuotaFilter,
  QuotaMatch,
} from './quota-filter';

export class SurveyNestedQuotasUpdater {
  constructor(private _nestedQuotas: NestedQuota[]) {}

  public update(
    match: QuotaMatch,
    update: Partial<NestedQuota>
  ): NestedQuota[] {
    const filter = new QuotaFilter(this._nestedQuotas);
    const matched = filter.quotas(match);
    const unmatched = filter.unmatched().quotas(match);
    const updatedMatch = matched.map((q) => ({ ...q, ...update }));
    return [...updatedMatch, ...unmatched];
  }
}

export class DefaultNestingGroupIdUpdater {
  private _defaultId = DEFAULT.NESTED_GROUP_KEY;
  constructor(private _nestedQuotas: NestedQuota[]) {}

  public update() {
    const hasNoNestingGroupIdMatch = new MissingNestingGroupIdQuotaMatch();
    const update = {
      group_key: this._defaultId,
    };
    return new SurveyNestedQuotasUpdater(this._nestedQuotas).update(
      hasNoNestingGroupIdMatch,
      update
    );
  }
}
